export const DEFAULT_PANE_HEADER_HEIGHT = 78;
